import scope from "./scope";

export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition, commit) => ({
  type: SET_DEFINITION,
  idx,
  definition,
  commit,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});
